'use strict';

// Reasons a saved card cannot be used for auto renew; see server/controllers-fn/validate/cardIssues.js
const CARD_ISSUES = {
  EXPIRED: 'EXPIRED',
  MISSING_DOMICILE_ADDRESS: 'MISSING_DOMICILE_ADDRESS',
  INVALID_DOMICILE_ADDRESS: 'INVALID_DOMICILE_ADDRESS'
};

const CARD_ISSUE_MESSAGES = {
  [CARD_ISSUES.EXPIRED]: 'This card has expired. Please update the expiration date or add a new card.',
  [CARD_ISSUES.MISSING_DOMICILE_ADDRESS]:
    'The company (domicile) address for this card is missing. Please complete it below and click Update Card.',
  [CARD_ISSUES.INVALID_DOMICILE_ADDRESS]:
    'The company (domicile) address for this card could not be validated. Please correct it below and click Update Card.'
};

module.exports = { CARD_ISSUES, CARD_ISSUE_MESSAGES };
